import React from "react";
import { Helmet } from "react-helmet";
import manifest from "../../data/manifest";

export default function KompassSchema() {
  const listItems = manifest.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.title,
    "description": item.text,
  }));

  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Kompass – Lern- und Systemarchitektur von Denis Bitter",
    "alternateName": "Lehransatz & EdTech-Systeme",
    "headline": "Kompass – Wie ich digitale Bildung mit Substanz gestalte",
    "image": `${process.env.PUBLIC_URL}/images/kompass1.svg`,
    "logo": {
      "@type": "ImageObject",
      "url": `${process.env.PUBLIC_URL}/images/kompass1.svg`,
      "width": 240,
      "height": 240
    },
    "description":
      "Ich entwickle EdTech-Lösungen, die lehrbar sind – und lehre, wie man Systeme denkt. Der Kompass zeigt, wie Lernen digital, menschlich und tragfähig wird.",
    "url": "https://www.denisbitter.de/kompass",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": listItems
    },
    "keywords": [
      "EdTech",
      "Lernarchitektur",
      "Systemarchitektur",
      "Digitale Bildung",
      "UX Design",
      "Webentwicklung",
      "Appentwicklung",
      "Denis Bitter",
      "Full Stack Entwicklung",
      "Lernformate",
      "Projektbasiertes Lernen"
    ],
    "creator": {
      "@type": "Person",
      "name": "Denis Bitter",
      "url": "https://www.denisbitter.de/about",
      "sameAs": [
        "https://www.instagram.com/denisbitter",
        "https://www.linkedin.com/in/denisbitter",
        "https://www.facebook.com/denisbitter",
        "https://www.youtube.com/@denisbitterfullstack",
        "https://www.tiktok.com/@theoriginalbitter",
        "https://www.x.com/theoriginalbitter"
      ]
    },
    "educationalFramework": "Projektorientiertes, beziehungsbasiertes Lernen mit Systemfokus",
    "educationalAudience": {
      "@type": "EducationalAudience",
      "educationalRole": "Lernende, Entwickler:innen, Medienmenschen, Quereinsteiger, Bildungsträger"
    },
    "hasPart": manifest.map((item) => ({
      "@type": "CreativeWork",
      "name": item.title,
      "description": item.text
    })),
    "publisher": {
      "@type": "Person",
      "name": "Denis Bitter",
      "url": "https://www.denisbitter.de/about"
    },
    "potentialAction": {
      "@type": "ReadAction",
      "target": ["https://www.denisbitter.de/kompass"]
    },
    "inLanguage": "de"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
